module.exports = __webpack_public_path__ + "img/huawei badge.ef72ac12.png";